// src/app/services/global-error-handler.ts

import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const msg = error?.message || '';

    // Chunk-Load-Fehler abfangen (Angular lazy loading)
    if (/Loading chunk [\w-]+ failed/.test(msg) ||
        /Failed to fetch dynamically imported module/.test(msg)) {

      const lastReload = sessionStorage.getItem('last-chunk-reload');
      const now = Date.now();

      // Reload nur wenn letzter Reload > 10s her (Loop-Schutz)
      if (!lastReload || now - parseInt(lastReload, 10) > 10_000) {
        sessionStorage.setItem('last-chunk-reload', now.toString());
        window.location.reload();
        return;
      }
    }

    // Alle anderen Fehler normal loggen
    console.error('[GlobalErrorHandler]', error);
  }
}
